export default __webpack_public_path__ + "static/media/Verdana-Italic.e566779c.ttf";